import { render, staticRenderFns } from "./OfferToCustomer.vue?vue&type=template&id=f544c7f0&"
import script from "./OfferToCustomer.vue?vue&type=script&lang=js&"
export * from "./OfferToCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports